import React, { useState } from 'react'
import { useTranslation } from '../../hooks/useTranslation'
import { useExercise } from './ExerciseProvider'
import { AylaButton } from './Buttons'
import { Textarea } from '../../lib/ui/textarea'
import AylaResponseScrollArea from '../ShortCourses/AylaResponseScrollArea'
import SavedStatusIcon from '../shared/SavedStatusIcon'
import AylaLoading from '../shared/AylaLoading'

const ReasonForLeavingSectionTwo = () => {
  const {
    updateResponse,
    getResponse,
    formattedExerciseName,
    exerciseIndex,
    requestAylaStatement,
    saveExercise,
    embedExercise,
  } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const craftYourResponse = t('pages.1.craft_your_response')
  const askAyla = t('pages.1.ask_ayla')
  const aylaInstructions = t('pages.1.ayla_instructions')

  const [submitted, setSubmitted] = useState(false)
  const [aylaResponse, setAylaResponse] = useState('')
  const [displayedText, setDisplayedText] = useState('')
  const [index, setIndex] = useState(0)
  const [typingComplete, setTypingComplete] = useState(false)
  const [statementType, setStatementType] = useState('')
  const [loadingStatus, setLoadingStatus] = useState(null)
  const showCursor = submitted && displayedText.length <= 0

  const handleChange = (section, slug, event) => {
    const response = event.target.value
    updateResponse(section, slug, response)
  }

  const handleAylaStatement = async (statementType) => {
    setSubmitted(true)
    setLoadingStatus('loading')
    setAylaResponse('')
    setDisplayedText('')
    setIndex(0)
    setTypingComplete(false)
    setStatementType(statementType)
    try {
      if (embedExercise) {
        await saveExercise()
      }
      await getAylaData(statementType)
    } catch (error) {
      console.error('Error saving exercise:', error)
    }
  }

  const getAylaData = async (statementType) => {
    try {
      const data = await requestAylaStatement(statementType)
      setAylaResponse(data.response)
      setLoadingStatus('complete')
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const handleUseThisStatement = () => {
    updateResponse(exerciseIndex, 'user_crafted_statement', aylaResponse)
  }

  const loadingStatusLinkedIn =
    statementType === 'LinkedIn' ? loadingStatus : null
  const loadingStatusProfessionalConnections =
    statementType === 'Professional Connections' ? loadingStatus : null

  return (
    <>
      <div>
        <div className="subtitle mb-4">{craftYourResponse}</div>
        <Textarea
          className="min-h-[175px] w-full rounded-[20px]"
          onChange={(e) =>
            handleChange(exerciseIndex, 'user_crafted_statement', e)
          }
          value={getResponse(exerciseIndex, 'user_crafted_statement') || ''}
        />
      </div>
      <div className="mt-8">
        <div className="subtitle mb-4">{askAyla}</div>
        <p className="mb-4">{aylaInstructions}</p>
        <div className="flex gap-12">
          <AylaButton onClick={() => handleAylaStatement('LinkedIn')}>
            {t('pages.1.linkedin')}
            <SavedStatusIcon loadingStatus={loadingStatusLinkedIn} />
          </AylaButton>
          <AylaButton
            onClick={() => handleAylaStatement('Professional Connections')}
          >
            {t('pages.1.professional_connections')}
            <SavedStatusIcon
              loadingStatus={loadingStatusProfessionalConnections}
            />
          </AylaButton>
        </div>
        {submitted && (
          <div className="subtitle my-4">
            {statementType === 'LinkedIn'
              ? t('pages.1.ayla_response_linkedin')
              : t('pages.1.ayla_response_professional')}
          </div>
        )}
        {loadingStatus === 'loading' && (
          <div className="flex items-center justify-center">
            <AylaLoading />
          </div>
        )}
        {loadingStatus === 'complete' && (
          <AylaResponseScrollArea
            showBorder={submitted}
            showCursor={showCursor}
            aylaResponse={aylaResponse}
            typingComplete={typingComplete}
            setTypingComplete={setTypingComplete}
            displayedText={displayedText}
            setDisplayedText={setDisplayedText}
            index={index}
            setIndex={setIndex}
            className="mb-4 h-48"
          ></AylaResponseScrollArea>
        )}
        {typingComplete && (
          <AylaButton onClick={handleUseThisStatement}>
            {t('pages.1.use_this_statement')}
          </AylaButton>
        )}
      </div>
    </>
  )
}

export default ReasonForLeavingSectionTwo
